import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../utils/api';

export default function Layout({ children }) {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [noLeidas, setNoLeidas] = useState(0);

  useEffect(() => {
    API.get('/app/notificaciones')
      .then(r => setNoLeidas(r.data.filter(n => !n.leida).length))
      .catch(() => {});
  }, [location.pathname]);

  const tabs = [
    { path: '/',              icon: '🏠', label: 'Inicio' },
    { path: '/horario',       icon: '📅', label: 'Horario' },
    { path: '/colillas',      icon: '💵', label: 'Pagos' },
    { path: '/agente',        icon: '🤖', label: 'Latu' },
    { path: '/notificaciones',icon: '🔔', label: 'Alertas', badge: noLeidas },
  ];

  const isActive = (path) => path === '/'
    ? location.pathname === '/'
    : location.pathname.startsWith(path);

  return (
    <div style={{ minHeight:'100dvh', display:'flex', flexDirection:'column', background:'#F9FAFB', paddingBottom:'calc(70px + env(safe-area-inset-bottom))' }}>
      {/* Header */}
      <div style={{ background:'#1a1a2e', padding:'14px 20px 14px', display:'flex', alignItems:'center', justifyContent:'space-between', position:'sticky', top:0, zIndex:100 }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <span style={{ fontSize:22 }}>🧁</span>
          <div>
            <div style={{ color:'white', fontWeight:800, fontSize:16 }}>Gelatus</div>
            <div style={{ color:'rgba(255,255,255,0.5)', fontSize:11 }}>{usuario?.nombre}</div>
          </div>
        </div>
        <button onClick={logout} style={{ background:'rgba(255,255,255,0.1)', border:'none', color:'white', padding:'6px 12px', borderRadius:8, fontSize:12, cursor:'pointer' }}>
          Salir
        </button>
      </div>

      {/* Contenido */}
      <div style={{ flex:1, display:'flex', flexDirection:'column', padding:'16px 20px 0', minHeight:0 }}>
        {children}
      </div>

      {/* Nav inferior */}
      <div style={{ position:'fixed', bottom:0, left:0, right:0, background:'white', borderTop:'1px solid #E5E7EB', display:'flex', zIndex:100, paddingBottom:'env(safe-area-inset-bottom)' }}>
        {tabs.map(t => (
          <button key={t.path} onClick={() => navigate(t.path)}
            style={{ flex:1, padding:'10px 4px 8px', border:'none', background:'transparent', cursor:'pointer', display:'flex', flexDirection:'column', alignItems:'center', gap:2, position:'relative' }}>
            <span style={{ fontSize:20, filter: isActive(t.path)?'none':'grayscale(1) opacity(0.5)' }}>{t.icon}</span>
            <span style={{ fontSize:10, fontWeight: isActive(t.path)?700:400, color: isActive(t.path)?'#1a1a2e':'#9CA3AF' }}>{t.label}</span>
            {t.badge > 0 && (
              <span style={{ position:'absolute', top:6, right:'calc(50% - 14px)', background:'#EF4444', color:'white', borderRadius:10, fontSize:10, fontWeight:800, padding:'1px 5px', minWidth:16, textAlign:'center' }}>
                {t.badge}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
